export const libertyContent = {
    banner: {
        title: 'Find out more about our BizCare Insurance.',
        titleBm: 'Ketahui lebih lanjut tentang pelan Insurans BizCare kami',
        desc: "Safeguarding your business is our priority, giving you the peace of mind that you require to ensure that your daily operations run smoothly. Whether you're running a brand new start-up, a family business or part of a large conglomerate, we at Liberty Insurance understand the importance of being able to provide your customers with an uninterrupted service. In the event of a sudden calamity, let us take on the burden of ensuring that your business is well-protected, allowing you to focus on the tasks that matter the most.",
        descBm: 'Adalah menjadi keutamaan kami untuk melindungi perniagaan dan memberikan ketenangan fikiran yang anda perlukan bagi memastikan operasi harian berjalan lancar. Sama ada anda baru sahaja memulakan syarikat, menjalankan perniagaan keluarga atau daripada konglomerat besar, kami di Liberty Insurance memahami kepentingan anda dan sediakan perkhidmatan yang mudah kepada pelanggan kami. Sekiranya berlaku bencana secara tiba-tiba, kami bertanggungjawab untuk memastikan perniagaan anda dilindungi dengan baik dan membolehkan anda memberi tumpuan kepada tugasan lain yang penting.',
    },
    product: {
        desc: `<span class='tw-text-[#FF6700] tw-font-semibold'>BizCare</span> is All in One comprehensive insurance package - Broad enough to ensure you have sufficient cover, tailored to your business needs.`,
        descBm: `<span class='tw-text-[#FF6700] tw-font-semibold'>BizCare</span> ialah pakej insurans komprehensif yang meliputi banyak faedah untuk memastikan anda mempunyai perlindungan yang sesuai dan mengikut keperluan peniagaan anda.`,
    },
    who: {
        title: 'Who is this subscription for?',
        titleBm: 'Untuk siapa langganan ini?',
        desc: 'Designed for business owners who want a hassle-free, all-in-one insurance solution tailored to their specific needs. Whether you run a small business, a retail store, a corporate office, or a larger enterprise, this comprehensive package ensures that your business is protected against a wide range of risks. If you’re looking for coverage that safeguards your assets, employees, and operations from potential financial losses due to fire, burglary, accidents, liability claims, or even terrorism, BizCare is the ideal choice',
        descBm: 'Direka khas untuk pemilik perniagaan yang mahukan penyelesaian perlindungan serba lengkap tanpa sebarang kerumitan dan disesuaikan mengikut keperluan khusus peniaga. Sama ada anda menjalankan perniagaan kecil-kecilan, kedai runcit, pejabat korporat atau perusahaan yang besar, pakej komprehensif ini memastikan perniagaan anda dilindungi daripada pelbagai risiko. Jika anda sedang mencari perlindungan yang melindungi aset, pekerja dan operasi perniagaan anda daripada potensi kerugian kewangan akibat kebakaran, rompakan, kemalangan, tuntutan liabiliti atau keganasan, BizCare adalah pilihan yang ideal dan tepat untuk anda.',
    },
    benefits: {
        title: 'What are the benefits?',
        titleBm: 'Apakah faedahnya?',
        options: [
            {
                img: '/assets/images/insurance/Fire.png',
                title: 'Fire (Compulsory)',
                titleBm: 'Kebakaran (Wajib)',
                desc: 'Covers loss or damage to your building and contents resulting from fire, lighting or explosion.',
                descBm: 'Melindungi kerugian atau kerosakan bangunan serta isi kandungan bangunan akibat daripada kebakaran, petir atau letupan gas domestik.',
                addFeat: "<span class='tw-font-medium'>Additional features:</span> <br/> Claims preparation, Temporary Protection Costs, Exclusive Trace & Access, Seasonal Increase in Stock.",
                addFeatBm: "<span class='tw-font-medium'>Perlindungan Tambahan:</span> <br/> Klausa Penyediaan Tuntutan, Kos Perlindungan Sementara, Perlindungan Jejak & Akses Eksklusif*, Peningkatan Stok Bermusim.",
            },
            {
                img: '/assets/images/insurance/Business-Interruption.png',
                title: 'Business Interruption <br/> (Fire Consequential Loss)',
                titleBm: 'Gangguan Perniagaan <br/> (Kerugian Akibat Kebakaran)',
                desc: 'Protects you against financial loss incurred due to loss or damage to your property insured under fire coverage.',
                descBm: 'Melindungi anda daripada kerugian kewangan disebabkan oleh kerugian atau kerosakan harta benda yang diinsuranskan di bawah perlindungan kebakaran.',
                addFeat: '',
                addFeatBm: '',
            },
            {
                img: '/assets/images/insurance/Other-Coverage.png',
                title: 'Other Coverage',
                titleBm: 'Perlindungan Lain',
                desc: '',
                descBm: '',
                addFeat: 'Accidental Risk (Limited All Risk), Burglary, Money, Plate Glass, Public Liability, Employer Liability, Fidelity Guarantee, Group Personal Accident, Terrorism Insurance.',
                addFeatBm: 'Risiko Akibat Kemalangan (Semua Risiko Terhad), Kecurian, Wang, Kepingan Kaca, Liabiliti Awam, Liabiliti Majikan, Jaminan Kesetiaan, Kemalangan Peribadi Kumpulan, Insurans Keganasan.',
            },
        ],
    },
    form: {
        title: `Apply now for <span class='tw-text-[#FF6700] tw-font-semibold'>BizCare</span>`,
        titleBm: 'Mohon sekarang.',
        desc: 'Only one more step to getting the support that you need - contact us now!',
        descBm: 'Hanya satu langkah lagi untuk mendapatkan sokongan yang anda perlukan - hubungi kami sekarang!',
        fields: {
            name: 'Name',
            nameBm: 'Nama',
            email: 'Email',
            emailBm: 'Alamat e-mel',
            phone: 'Phone No.',
            phoneBm: 'Nombor telefon',
            company: 'Company Name',
            companyBm: 'Nama Syarikat',
            insuranceType: 'Type of Insurance',
            insuranceTypeBm: 'Jenis Insurans',
            brn: 'Business Registration Number',
            brnBm: 'Nombor Pendaftaran Perniagaan',
            insuranceOptions: [
                { en: 'Fire (Compulsory)', bm: 'Kebakaran (wajib)' },
                {
                    en: 'Business Interruption (Fire Consequential Loss)',
                    bm: 'Gangguan Perniagaan(Kerugian Akibat Kebakaran)',
                },
                {
                    en: 'Accidental Risk (Limited All Risks)',
                    bm: 'Risiko Akibat Kemalangan',
                },
                { en: 'Burglary', bm: 'Kecurian' },
                { en: 'Money', bm: 'Wang' },
                { en: 'Plate Glass', bm: 'Kepingan Kaca' },
                { en: 'Public Liability', bm: 'Liabiliti Awam' },
                { en: "Employer's Liability", bm: 'Liabiliti Majikan' },
                { en: 'Fidelity Guarantee', bm: 'Jaminan Kesetiaan' },
                {
                    en: 'Group Personal Accident',
                    bm: 'Kemalangan Peribadi Kumpulan',
                },
                { en: 'Terrorism Insurance', bm: 'Insurans Keganasan' },
            ],

            natureOfBusinessOptions: [
                { en: 'Individual', bm: 'Individu' },
                { en: 'Sole Proprietorship', bm: 'Pemilikan Tunggal' },
                { en: 'Partnership', bm: 'Perkongsian' },
                {
                    en: 'Professional Service Providers',
                    bm: 'Penyedia Perkhidmatan Profesional',
                },
                { en: 'Sendirian Berhad', bm: 'Sendirian Berhad' },
                {
                    en: 'Limited Liability Partnership',
                    bm: 'Perkongsian Liabiliti Terhad',
                },
            ],
            terms: "By clicking 'Submit', you agree that you have given consent for us to contact you regarding your product application, and you further confirm that you have fully read, understood and agree to be bound by the terms of Liberty General Insurance Berhad's <a class='tw-text-blue-600 tw-underline tw-cursor-pointer' href='https://www.kurnia.com/privacy-policy-documents' target='_blank'  >Privacy Notice</a> and consent to the collection, process, usage, disclosure and retention of your personal data as described in the Privacy Notice.",
            termsBm:
                "Dengan menekan 'Hantar', anda bersetuju bahawa anda telah memberi kebenaran untuk kami menghubungi anda mengenai permohonan produk anda, dan anda turut mengesahkan bahawa anda telah membaca sepenuhnya, memahami dan bersetuju untuk terikat dengan terma <a class='tw-text-blue-600 tw-underline tw-cursor-pointer' href='https://www.kurnia.com/privacy-policy-documents' target='_blank'  >Notis Privasi</a> Liberty General Insurance Berhad dan bersetuju terhadap pengumpulan, pemprosesan, penggunaan, pendedahan dan penyimpanan data peribadi anda seperti yang diterangkan dalam Notis Privasi.",
        },
        errors: {
            name: 'Please enter Applicant Name that is valid up to 30 Characters (required)',
            nameBm: 'Sila masukkan Nama Pemohon yang sah sehingga 30 Aksara (wajib)',
            email: 'Please enter valid Email Address (required)',
            emailBm: 'Sila masukkan Alamat e-mel  yang sah (wajib)',
            phone: 'Phone number should be a valid phone number',
            phoneBm: 'Sila masukkan nombor telefon yang sah.',
            company:
                'Please enter Company Name that is valid up to 50 Characters (required)',
            companyBm:
                'Sila masukkan Nama Syarikat yang sah sehingga 50 Aksara (wajib)',
            terms: 'Please accept Terms & Conditions',
            termsBm: 'Sila terima Terma & Syarat',
            insuranceType:
                'Please tick at least a Type of Insurance (required).',
            insuranceTypeBm: 'Sila pilih minimum 1 Jenis Insurans (wajib).',
            natureOfBusiness: '	Please make a selection (required)',
            natureOfBusinessBm: 'Sila pilih yang bersesuaian (wajib)',
            brn: 'Please enter a valid Business Registration No.',
            brnBm: 'Sila taipkan Nombor Pendaftaran Perniagaan yang sah',
        },
    },
};
